import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, computed, isObservableArray, runInAction, toJS, makeObservable, override } from "mobx";
import Mustache from "mustache";
import AsyncLoader from "../Core/AsyncLoader";
import isDefined from "../Core/isDefined";
import { isJsonObject, isJsonString } from "../Core/Json";
import hasTraits from "../Models/Definition/hasTraits";
import updateModelFromJson from "../Models/Definition/updateModelFromJson";
import CatalogMemberReferenceTraits from "../Traits/TraitsClasses/CatalogMemberReferenceTraits";
import AccessControlMixin from "./AccessControlMixin";
import GroupMixin from "./GroupMixin";
import MappableMixin from "./MappableMixin";
import ReferenceMixin from "./ReferenceMixin";
function CatalogMemberMixin(Base) {
  var _class;
  let CatalogMemberMixin = (_class = class CatalogMemberMixin extends AccessControlMixin(Base) {
    // The names of items in the CatalogMember's info array that contain details of the source of this CatalogMember's data.
    // This should be overridden by children of this class. For an example see the WebMapServiceCatalogItem

    constructor() {
      super(...arguments);
      _defineProperty(this, "_sourceInfoItemNames", undefined);
      _defineProperty(this, "_metadataLoader", new AsyncLoader(this.forceLoadMetadata.bind(this)));
      makeObservable(this);
    }
    get typeName() {
      return;
    }
    get loadMetadataResult() {
      return this._metadataLoader.result;
    }

    /**
     * Gets a value indicating whether metadata is currently loading.
     */
    get isLoadingMetadata() {
      return this._metadataLoader.isLoading;
    }
    get isLoading() {
      return this.isLoadingMetadata || MappableMixin.isMixedInto(this) && this.isLoadingMapItems || ReferenceMixin.isMixedInto(this) && this.isLoadingReference || GroupMixin.isMixedInto(this) && this.isLoadingMembers;
    }

    /** Calls AsyncLoader to load metadata. It is safe to call this as often as necessary.
     * If metadata is already loaded or already loading, it will
     * return the existing promise.
     *
     * This returns a Result object, it will contain errors if they occur - they will not be thrown.
     * To throw errors, use `(await loadMetadata()).throwIfError()`
     *
     * {@see AsyncLoader}
     */
    async loadMetadata() {
      return (await this._metadataLoader.load()).clone({
        message: "Failed to load `".concat(getName(this), "` metadata"),
        importance: -1
      });
    }

    /**
     * Forces load of the metadata. This method does _not_ need to consider
     * whether the metadata is already loaded.
     *
     * You **can not** make changes to observables until **after** an asynchronous call {@see AsyncLoader}.
     *
     * Errors can be thrown here.
     *
     * {@see AsyncLoader}
     */
    async forceLoadMetadata() {}
    get hasCatalogMemberMixin() {
      return true;
    }
    get inWorkbench() {
      return this.terria.workbench.contains(this);
    }
    get name() {
      return super.name || this.uniqueId;
    }
    get nameInCatalog() {
      return super.nameInCatalog || this.name;
    }
    get nameSortKey() {
      const parts = (this.nameInCatalog || "").split(/(\d+)/);
      return parts.map(function (part) {
        const parsed = parseInt(part, 10);
        if (parsed === parsed) {
          return parsed;
        } else {
          return part.trim().toLowerCase();
        }
      });
    }
    get hasDescription() {
      return isJsonString(this.description) && this.description.length > 0 || isObservableArray(this.info) && this.info.some(info => descriptionRegex.test(info.name || ""));
    }
    get infoAsObject() {
      const infoObject = {};
      this.info.forEach(infoItem => {
        if (infoItem.name !== undefined && infoItem.name.length > 0) {
          const infoNameNoSpaces = infoItem.name.replace(/ /g, "");
          if (isDefined(infoItem.content) && !isDefined(infoObject[infoNameNoSpaces])) {
            infoObject[infoNameNoSpaces] = infoItem.content;
          } else if (isDefined(infoItem.contentAsObject)) {
            infoObject[infoNameNoSpaces] = infoItem.contentAsObject;
          }
        }
      });
      return infoObject;
    }
    get infoWithoutSources() {
      const sourceInfoItemNames = this._sourceInfoItemNames;
      if (sourceInfoItemNames === undefined) {
        return this.info;
      } else {
        return this.info.filter(infoItem => {
          if (infoItem.name === undefined) return true;
          return sourceInfoItemNames.indexOf(infoItem.name) === -1;
        });
      }
    }

    /** Converts modelDimensions to selectableDimensions
     * This will apply modelDimension JSON value to user stratum
     */
    get selectableDimensions() {
      var _this$modelDimensions;
      return (_this$modelDimensions = this.modelDimensions.map(dim => ({
        id: dim.id,
        name: dim.name,
        selectedId: dim.selectedId,
        disable: dim.disable,
        allowUndefined: dim.allowUndefined,
        options: dim.options,
        setDimensionValue: (stratumId, selectedId) => {
          var _dim$options$find;
          runInAction(() => dim.setTrait(stratumId, "selectedId", selectedId));
          const value = (_dim$options$find = dim.options.find(o => o.id === selectedId)) === null || _dim$options$find === void 0 ? void 0 : _dim$options$find.value;
          if (isDefined(value)) {
            const result = updateModelFromJson(this, stratumId, mustacheNestedJsonObject(toJS(value), this));
            result.raiseError(this.terria, "Failed to update catalog item ".concat(getName(this)));

            // If no error then call loadMapItems
            if (!result.error && MappableMixin.isMixedInto(this)) {
              this.loadMapItems().then(loadMapItemsResult => {
                loadMapItemsResult.raiseError(this.terria);
              });
            }
          }
        }
      }))) !== null && _this$modelDimensions !== void 0 ? _this$modelDimensions : [];
    }
    get viewingControls() {
      return [];
    }
    dispose() {
      super.dispose();
      this._metadataLoader.dispose();
    }
  }, _applyDecoratedDescriptor(_class.prototype, "isLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "inWorkbench", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "inWorkbench"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "name", [override], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nameInCatalog", [override], Object.getOwnPropertyDescriptor(_class.prototype, "nameInCatalog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nameSortKey", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "nameSortKey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "infoAsObject", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "infoAsObject"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "infoWithoutSources", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "infoWithoutSources"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectableDimensions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectableDimensions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewingControls", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "viewingControls"), _class.prototype), _class);
  return CatalogMemberMixin;
}
const descriptionRegex = /description/i;
(function (_CatalogMemberMixin2) {
  function isMixedInto(model) {
    return model && model.hasCatalogMemberMixin;
  }
  _CatalogMemberMixin2.isMixedInto = isMixedInto;
})(CatalogMemberMixin || (CatalogMemberMixin = {}));
export default CatalogMemberMixin;

/** Convenience function to get user readable name of a BaseModel */
export const getName = action(model => {
  var _ref, _ref2, _ref3;
  return (_ref = (_ref2 = (_ref3 = CatalogMemberMixin.isMixedInto(model) ? model.name : undefined) !== null && _ref3 !== void 0 ? _ref3 : hasTraits(model, CatalogMemberReferenceTraits, "name") ? model.name : undefined) !== null && _ref2 !== void 0 ? _ref2 : model === null || model === void 0 ? void 0 : model.uniqueId) !== null && _ref !== void 0 ? _ref : "Unknown model";
});

/** Recursively apply mustache template to all nested string properties in a JSON Object */
function mustacheNestedJsonObject(obj, view) {
  return Object.entries(obj).reduce((acc, _ref4) => {
    let [key, value] = _ref4;
    if (isJsonString(value)) {
      acc[key] = Mustache.render(value, view);
    } else if (isJsonObject(value, false)) {
      acc[key] = mustacheNestedJsonObject(value, view);
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
}